module.exports = __webpack_public_path__ + "5e16d11b6b28de0db1c315639316c257.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/image1.png
 ** module id = 279
 ** module chunks = 0
 **/